import { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'

const borderRadius = '4px'

export const popover = ({ theme }: WithRequiredTheme): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,

  boxShadow: '0 8px 20px 0 rgba(0, 0, 0, .16)',
  borderRadius,
})

export const editView: CSSObject = {
  minInlineSize: '275px',
}

export const content: CSSObject = {
  paddingBlock: '20px',
  paddingInline: '12px',
}

export const inputContainer: CSSObject = {
  '&:not(:last-of-type)': {
    marginBlockEnd: '12px',
  },
}

export const actions = ({ theme }: WithRequiredTheme): CSSObject => ({
  backgroundColor: Color[theme].Surface.N200,

  display: 'flex',
  justifyContent: 'flex-end',
  padding: '8px',
  borderEndStartRadius: borderRadius,
  borderEndEndRadius: borderRadius,

  '> button': {
    marginInlineStart: '8px',
  },
})

export const actionView: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  gap: '8px',
  padding: '8px',
}

export const actionViewButtonsWrapper = ({
  theme,
}: WithRequiredTheme): CSSObject => ({
  borderInlineStart: `1px solid ${Color[theme].Surface.N300}`,
  display: 'flex',
  gap: 8,
  blockSize: '100%',
  paddingInlineStart: 8,
})
